module.exports = __webpack_public_path__ + "static/media/Illus-Apple_Wallet@2x.4a4a7b96.png";